import { useEffect, useMemo } from 'react';

import useSessionStorage from './useSessionStorage';

const useQueryFeature = (requestedFeature: string) => {
  const searchParams =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams();

  type OptionsTypes = {
    [key: string]: string;
  };
  const options = {} as OptionsTypes;

  // Handle multiple feature parameters: ?feature=new-theme&feature=amRevamp
  // or single comma-separated: ?feature=new-theme,amRevamp
  const featureParams = searchParams.getAll('feature');
  const allFeatures = featureParams.flatMap((param) => param.split(','));
  const featureList = allFeatures.filter(Boolean);

  const [featureFlags, setFeatureFlags] = useSessionStorage(
    'featureFlags', // local storage key
    featureList, // local storage default value
  );

  useEffect(() => {
    if (!!requestedFeature && featureList?.includes(requestedFeature)) {
      setFeatureFlags(featureList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureList.join(',')]);

  const isFeatureEnabled = useMemo(
    () => featureFlags?.includes(requestedFeature),
    [featureFlags, requestedFeature],
  );

  //The rest of params are mapped to an "options" object
  for (const [key, value] of searchParams.entries()) {
    if (key !== 'feature') {
      options[key] = value;
    }
  }

  return [!!isFeatureEnabled, options] as [boolean, OptionsTypes];
};

export default useQueryFeature;
